import React from 'react';
import {connect} from 'react-redux';
import PropTypes from "prop-types";
import {setLevelfilter} from "../actions/layersext";
import LocaleUtils from "qwc2/utils/LocaleUtils";
import '../style/LevelFilter.css';

class LevelFilter extends React.Component {
    static propTypes = {
        levelFilter: PropTypes.number,
        levelFilterMax: PropTypes.number,
        levelFilterMin: PropTypes.number,
        setLevelfilter: PropTypes.func
    }
    static defaultProps = {
        levelFilter: 0,
        levelFilterMin: 0,
        levelFilterMax: 3
    }

    constructor(props) {
        super(props);
        this.state = {
            currentTab: ''
        };
    }

    componentDidUpdate() {
    }


    setLevelfilter(newLevel) {
        this.props.setLevelfilter(newLevel);
    }

    render() {
        const levelFilterList = [];
        for (let i = this.props.levelFilterMin; i <= this.props.levelFilterMax; i++) {
            const number = Math.abs(i);
            let label;
            if (i == 0) {
                label = LocaleUtils.tr("levels.zero");
            } else if (i > 0) {
                label = number + '. ' + LocaleUtils.tr("levels.over");
            } else {
                label = number + '. ' + LocaleUtils.tr("levels.under");
            }
            levelFilterList.push({
                value: String(i),
                label: label
            });
        }

        let levelLower = false;
        let levelHigher = false;
        if (this.props.levelFilter > this.props.levelFilterMin) {
            levelLower = true;
        }
        if (this.props.levelFilter < this.props.levelFilterMax) {
            levelHigher = true;
        }
        return (
            <div className="level-filter">
                <button className="button" disabled={!levelLower} onClick={ev => this.setLevelfilter(this.props.levelFilter - 1)}><i className="icon icon-chevron-left"></i></button>
                <select name="levelfilter"
                        onChange={ev => this.setLevelfilter(ev.target.value)}
                        value={String(this.props.levelFilter)}
                >
                    {levelFilterList.map((item) => {
                        return (
                            <option key={item.value} value={String(item.value)}>{item.label}</option>
                        );
                    })}
                </select>
                <button className="button" disabled={!levelHigher} onClick={ev => this.setLevelfilter(this.props.levelFilter + 1)}><i className="icon icon-chevron-right"></i></button>
            </div>
        );
    }
}

const selector = (state) => ({
    levelFilter: state.layers.levelFilter
});

export default connect(selector, {
    setLevelfilter: setLevelfilter
})(LevelFilter);
